import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiError } from '../api/client.ts';
import { useAuth } from '../auth/AuthContext.tsx';
import './LoginScreen.css';

export function LoginScreen() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      await login(username.trim(), password);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Не удалось войти');
      setBusy(false);
    }
  }

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={submit}>
        <h2 className="login-title">Вход</h2>

        <label className="field-label" htmlFor="login-nickname">
          Никнейм
        </label>
        <input
          id="login-nickname"
          className="text-field login-field"
          value={username}
          onChange={(event) => setUsername(event.target.value)}
          autoComplete="username"
          autoCapitalize="none"
          autoFocus
        />

        <label className="field-label" htmlFor="login-password">
          Пароль
        </label>
        <input
          id="login-password"
          className="text-field login-field login-field-last"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          autoComplete="current-password"
        />

        <button className="primary-button" type="submit" disabled={busy}>
          Войти
        </button>

        {/* No signup affordance by design — accounts come from `npm run seed`. */}
        {error && <div className="form-error">{error}</div>}
      </form>
    </div>
  );
}
